import { API_URL } from '../config';

const TOKEN_KEY = 'mb_token';

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

/**
 * Thin fetch wrapper: attaches the JWT, parses JSON, and throws a normalised
 * error ({ message, details, status }) that pages/contexts can display.
 */
export async function apiFetch(path, { method = 'GET', body, auth = false, headers = {} } = {}) {
  const opts = { method, headers: { ...headers } };

  if (body !== undefined) {
    opts.headers['Content-Type'] = 'application/json';
    opts.body = JSON.stringify(body);
  }
  if (auth) {
    const token = tokenStore.get();
    if (token) opts.headers.Authorization = `Bearer ${token}`;
  }

  let res;
  try {
    res = await fetch(`${API_URL}${path}`, opts);
  } catch (networkErr) {
    const err = new Error('Cannot reach the server. Please try again.');
    err.status = 0;
    err.offline = true;
    throw err;
  }

  const isJson = (res.headers.get('content-type') || '').includes('application/json');
  const data = isJson ? await res.json() : null;

  if (!res.ok) {
    const err = new Error(data?.message || `Request failed (${res.status})`);
    err.status = res.status;
    err.details = data?.details;
    throw err;
  }
  return data;
}
